// The puzzle card's feedback colour, in its own module so Node's test runner
// can import it without JSX.

export type PuzzleCardStatus = 'playing' | 'thinking' | 'solved' | 'failed' | 'showing' | 'shown';
/** Green for a correct step or solved, red while a wrong move waits, neutral otherwise (including the solution playing itself). */
export type PuzzleCardTone = 'neutral' | 'good' | 'bad';

/** The tone for a state; `correct` is true for about a second after a correct step of a longer puzzle. */
export function toneOf(status: PuzzleCardStatus, correct = false): PuzzleCardTone {
  if (status === 'failed') return 'bad';
  if (status === 'solved') return 'good';
  if (correct && (status === 'playing' || status === 'thinking')) return 'good';
  return 'neutral';
}
